import { Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import GeneralSettings from "./sections/GeneralSettings";
import { updatePolicySection } from "../../redux/rtk/features/compOffPolicy/compOffPolicySlice";
import "./compOffPolicy.css";

/**
 * Reusable comp-off policy form.
 * @param {boolean} embedded - Compact layout inside leave policy modal
 */
export default function CompOffPolicyForm({ embedded = false, sidePanel = false }) {
	const dispatch = useDispatch();
	const { policy, loading } = useSelector((state) => state.compOffPolicy);

	const updateSection = (sectionKey) => (data) => {
		dispatch(updatePolicySection({ section: sectionKey, data }));
	};

	return (
		<div className={embedded ? "compoff-embedded" : "compoff-policy-form"}>
			<Spin spinning={loading}>
				<GeneralSettings
					embedded={embedded}
					sidePanel={sidePanel}
					general={policy.general}
					calculation={policy.calculation}
					onGeneralChange={updateSection("general")}
					onCalculationChange={updateSection("calculation")}
				/>
			</Spin>
		</div>
	);
}
